export default __webpack_public_path__ + "static/media/check_circle_black_24dp.f79b114b.svg";